import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Martín R.',
  age: 42,
  role: 'Capitán de charter en Mediterráneo',
  quote: 'Antes sentía que si no estaba yo encima de todo, el barco se venía abajo. Implementar este sistema me devolvió la tranquilidad. Ahora la tripulación sabe qué hacer y yo me dedico a lo que realmente importa: dirigir y asegurar la experiencia del cliente.'
}, {
  name: 'Diego L.',
  age: 35,
  role: 'Capitán en Caribe',
  quote: 'El mayor cambio fue en la coordinación. Los checklists y los sistemas para cada rol (especialmente el del chef y la azafata) eliminaron el 90% de las preguntas diarias. Es impresionante cómo cambia el ambiente a bordo cuando hay estructura.'
}, {
  name: 'Sebastián M.',
  age: 48,
  role: 'Capitán con 15 años de experiencia',
  quote: 'Pensé que por mi experiencia no necesitaba esto. Estaba equivocado. El caos operativo me estaba consumiendo. El Charter Command System estructuró mi cabeza y mi barco. Es la mejor inversión que hice en mi carrera.'
}, {
  name: 'Nicolás F.',
  age: 38,
  role: 'Capitán de yate en Croacia',
  quote: 'Los clientes lo notan. Esa es la verdad. Desde que usamos el sistema, el nivel de profesionalismo subió tanto que las propinas y las reservas repetidas aumentaron. No es magia, es simplemente tener todo bajo control.'
}, {
  name: 'Alejandro V.',
  age: 45,
  role: 'Capitán en Grecia',
  quote: 'Los bonus son una locura. Le di el sistema del ingeniero a mi mecánico y el de la azafata a la jefa de interior, y en dos días el barco funcionaba como un reloj suizo. Dejé de apagar incendios para empezar a liderar de verdad.'
}];
export function TestimonialsSection() {
  return <section className="py-10 md:py-20 bg-navy-800" data-id="element-205">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-206">
        <div className="text-center mb-8 md:mb-16" data-id="element-207">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-2 md:mb-4" data-id="element-208">
            Capitanes que ya dejaron de sobrevivir al caos
          </h2>
          <p className="text-lg md:text-xl text-slate-300" data-id="element-209">
            Resultados reales de profesionales en el agua.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-210">
          {testimonials.map((t, i) => <div key={i} className="bg-navy-900 p-5 md:p-8 rounded-2xl border border-navy-700 shadow-xl flex flex-col" data-id="element-211">
              <div className="flex gap-1 mb-3 md:mb-4" data-id="element-212">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 md:w-5 md:h-5 fill-gold-400 text-gold-400" data-id="element-213" />)}
              </div>
              <p className="text-sm md:text-base text-slate-300 italic mb-4 md:mb-6 flex-1" data-id="element-214">
                "{t.quote}"
              </p>
              <div className="border-t border-navy-700 pt-3 md:pt-4 mt-auto" data-id="element-215">
                <p className="font-bold text-white text-sm md:text-base" data-id="element-216">
                  {t.name}, {t.age} años
                </p>
                <p className="text-xs md:text-sm text-gold-400" data-id="element-217">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}